<template>
  <v-container class="px-6">
    <v-row class="d-flex align-center px-3 mb-1">
      <div>
        <h1>Lote de pagamento</h1>
        <p>Visualize os dados do lote</p>
      </div>
      <v-spacer />
      <AcoesLote
        v-if="isUsuarioTradimus || (isStatusCliente && canDoActions)"
        :lote="getPagamentoLoteById"
        :isUsuarioTradimus="isUsuarioTradimus"
        @updateLote="$asyncComputed.getPagamentoLoteById.update"
      />
    </v-row>
    <InformacoesPagamentoLote
      v-if="getPagamentoLoteById"
      :prestadora="getPagamentoLoteById?.prestador?.nome"
      :operadora="getPagamentoLoteById?.operadoraAns?.nome"
      :dataDePagamento="getPagamentoLoteById?.dataPagamento"
      :lote="getPagamentoLoteById"
      :isStatusCliente="isStatusCliente"
    />
    <div class="d-flex align-center pt-6" v-if="selectedGuiasIds.length === 0">
      <div>
        <p class="mb-0">Ordernar por</p>
        <v-select
          v-model="sorting"
          :items="sortGuias"
          :label="sorting"
          item-text="text"
          item-value="value"
          hide-details
          flat
          solo
          outlined
          dense
        />
        </div>
      <v-spacer />
      <FiltroLote
        :numeroCarteira.sync="numeroCarteira"
        :quantidadeItens.sync="quantidadeItens"
        :numeroGuiaPrestador.sync="numeroGuiaPrestador"
        @clearFilter="handleClearFilter"
      />
    </div>
    <div v-else class="pt-6">
      <AcoesGuias
        :guiasIds="selectedGuiasIds"
        :totalGuias="totalGuias"
        :loteId="loteId"
        :conciliacaoAutomaticaDisabled="conciliacaoAutomaticaDisabled"
        :finalizarConciliacaoDisabled="finalizarConciliacaoDisabled"
        :pagamentoId="pagamentoId"
        :hasConciliacaoItems="hasConciliacaoItems"
        :isUsuarioTradimus="isUsuarioTradimus"
        @selectAllGuias="selectAllGuias"
        @deselectAllGuias="deselectAllGuias"
        @reloadGuias="reloadGuias"
      />
    </div>

    <GuiasTabs
      :tabs="tabs"
      :selectedTabKey="selectedTabKey"
      @tabChange="handleTabChange"
    />

    <p class="text-center pt-6 pa-2" v-if="guias.length === 0" >
      Não há dados disponíveis
    </p>
    <v-pagination
      v-if="hasPagination"
      v-model="page"
      class="my-4"
      :length="paginationLength"
    />
    <ListaGuias
      :disableAcoesGuias="disableAcoesGuias"
      :loading="loading"
      :guias="guias"
      :quantidadeGuias="quantidadeGuias"
      :selectedGuias="selectedGuiasIds"
      :canDoActions="canDoActions"
      @guiaCheckboxClick="handleCheckboxClick"
    />
    <v-pagination
      v-if="hasPagination"
      v-model="page"
      class="my-4"
      :length="paginationLength"
    />
    <h2 class="py-6">Comentários</h2>
    <ComentariosPagamentoLote :pagamentoId="getPagamentoLoteById?.pagamentoId" :pagamentoLoteId="this.loteId"/>
  </v-container>
</template>

<script>
import { conciliacaoClient } from '../../libs/conciliacao-client'
import InformacoesPagamentoLote from '@/components/recebiveis/pagamento_lote/InformacoesPagamentoLote.vue'
import AcoesLote from '@/components/recebiveis/pagamento_lote/AcoesLote.vue'
import ListaGuias from '@/components/recebiveis/pagamento_lote/ListaGuias.vue'
import AcoesGuias from '@/components/recebiveis/pagamento_lote/AcoesGuias.vue'
import ComentariosPagamentoLote from '@/components/recebiveis/pagamento_lote/ComentariosPagamentoLote.vue'
import FiltroLote from './pagamento_lote/FiltroLote.vue'
import { sessionStorageClient } from '../../libs'
import GuiasTabs from './pagamento_lote/GuiasTabs.vue'

export default {
  data () {
    return {
      page: 1,
      sortGuias: [
        {
          text: 'Selecione',
          value: ''
        },
        {
          text: 'Maiores valores informado',
          value: '-valorInformado'
        },
        {
          text: 'Menores valores informado',
          value: 'valorInformado'
        },
        {
          text: 'Número de guia descendente',
          value: '-numeroGuiaPrestador'
        },
        {
          text: 'Número de guia ascendente',
          value: 'numeroGuiaPrestador'
        },
        {
          text: 'Maior índice de conciliação',
          value: ['-PercentualConciliadoValorAutomatico', '-PercentualConciliadoValorManual']
        },
        {
          text: 'Menor índice de conciliação',
          value: ['PercentualConciliadoValorAutomatico', 'PercentualConciliadoValorManual']
        }
      ],
      sorting: '',
      selectedGuiasIds: [],
      numeroCarteira: '',
      quantidadeItens: '',
      numeroGuiaPrestador: '',
      pagamento: null,
      selectedTabKey: 'pendentes',
      tabs: [
        {
          label: 'Todos',
          key: 'todos'
        },
        {
          label: 'Pendentes',
          key: 'pendentes'
        },
        {
          label: 'Finalizadas',
          key: 'finalizadas'
        }
      ],
      guiasFinalizadas: undefined,
      guiasPendentes: true
    }
  },
  components: {
    InformacoesPagamentoLote,
    AcoesLote,
    ListaGuias,
    AcoesGuias,
    FiltroLote,
    ComentariosPagamentoLote,
    GuiasTabs
},
  props: {
    pagamentoId: String,
    loteId: String
  },
  computed: {
    paginationLength () {
      return Math.ceil(this.getPagamentoGuiasPage?.totalSize/10) || 0
    },
    hasPagination () {
      return this.getPagamentoGuiasPage?.totalSize/10 > 1
    },
    totalGuias () {
      return this.getPagamentoGuiasPage?.data.length || 0
    },
    guias () {
      return this.getPagamentoGuiasPage?.data || []
    },
    quantidadeGuias () {
      return this.getPagamentoLoteById?.quantidadeGuias || 0
    },
    loading () {
      return this.getPagamentoGuiasPage?.loading || null
    },
    isStatusCliente () {
      const statusCliente = ['conciliacaoAutomaticaCliente', 'conciliacaoManualCliente', 'conclusaoPendente', 'gerandoArquivos', 'concluido']

      return statusCliente.includes(this.pagamento?.status)
    },
    isUsuarioTradimus () {
      const usuarioTradimus = sessionStorageClient.getItem('userData')?.['UsuarioTradimus']
      return usuarioTradimus
    },
    disableAcoesGuias () {
      return (!this.isUsuarioTradimus && this.isStatusCliente) || (this.isUsuarioTradimus && !this.isStatusCliente)
    },
    canDoActions () {
      const conclusaoStatus = ['gerandoArquivos', 'concluido']

      return !conclusaoStatus.includes(this.pagamento?.status)
    },
    conciliacaoAutomaticaDisabled () {
      return !this.getPagamentoLoteById.acoes.includes("ConciliarAutomaticamente")
    },
    finalizarConciliacaoDisabled () {
      return !this.getPagamentoLoteById.acoes.includes("FinalizarConciliacaoManual")
    },
    hasConciliacaoItems () {
      const selectedPagamentoGuias = this.guias.filter(guia => this.selectedGuiasIds.includes(guia.id))
      const hasConciliacaoItems = selectedPagamentoGuias.filter(guia => guia.hasConciliacaoItens)
      return hasConciliacaoItems.length > 0
    },
    filterQuery () {
      return {
        numeroCarteira: this.numeroCarteira,
        quantidadeItens: +this.quantidadeItens || null,
        numeroGuiaPrestador: this.numeroGuiaPrestador,
        guiasFinalizadas: this.guiasFinalizadas,
        guiasPendentes: this.guiasPendentes
      }
    }
  },
  asyncComputed: {
    getPagamentoLoteById: {
      get () {
        const params = {
          includePrestador: true,
          includeOperadoraAns: true,
          includePagamentoLotes: true
        }
        return conciliacaoClient.pagamentoLote.getPagamentoLoteById(this.loteId, params)
      }
    },
    getPagamentoGuiasPage: {
      get () {
        const params = {
          pagamentoLoteId: this.loteId,
          pageNumber: this.page - 1,
          pageSize :10,
          sorting: this.sorting,
          ...this.filterQuery
        }

        return conciliacaoClient.pagamentoGuia.getPagamentoGuiasPage (params)
      }
    }
  },
  methods: {
    handleCheckboxClick (params) { //Tipo: { guiaId: Number, checked: Boolean }
      if (params.checked) {
        this.selectedGuiasIds = this.selectedGuiasIds.filter(id => id !== params.guiaId)
      } else {
        this.selectedGuiasIds.push(params.guiaId)
      }
    },
    selectAllGuias () {
      this.selectedGuiasIds = this.getPagamentoGuiasPage?.data.map(item => item.id)
    },
    deselectAllGuias () {
      this.selectedGuiasIds = []
    },
    handleClearFilter () {
      this.numeroCarteira = ''
      this.quantidadeItens = ''
      this.numeroGuiaPrestador = ''
    },
    reloadGuias () {
      this.$asyncComputed.getPagamentoGuiasPage.update()
    },
    handleTabChange (key) {
      this.selectedTabKey = key

      this.guiasPendentes = key === 'pendentes' || undefined
      this.guiasFinalizadas = key === 'finalizadas' || undefined
    }
  },
  async mounted () {
    const pagamento = await conciliacaoClient.pagamento.getPagamentoById(this.pagamentoId)

    if (pagamento) {
      this.pagamento = pagamento
    }
  }
}
</script>
